import React from "react";
import { MarkerType } from "react-flow-renderer";
import astronautImage from "../images/nasa-astronaut-pic.jpg";
import whaleSpace from "../images/whalespace.jpg";

import astronaut2 from "../images/astronaut-2.png";

import { Link } from "react-router-dom";

// const level1 = "rgb(17,3,3, 0.1)";
// const level2 = "#5d1c53";
// const level3 = "rgb(20,28,39, 0.9)";
// const level4 = "#3c5475";
// const level5 = "#4517d1";
// const level6 = "#de723a";
// const black = "yellow";
// const white = "white";
// const transparent = "00FFFFFF";
// const spaceColor = "#141c26";

const level1 = "rgb(17, 3, 3, 0.1)";
const level2 = "rgb(0, 25, 59, 0.9)";
const level3 = "rgb(0, 25, 59, 0.9)";
const level4 = "#003379";
const level5 = "#0a0f17";
const level6 = "#de723a";
const black = "yellow";

export const nodes = [
  {
    id: "1",
    type: "input",
    data: {
      label: (
        <>
          <strong>Advanced Styling</strong>
        </>
      ),
    },
    position: { x: 0, y: 0 },
    style: {
      background: level1,
      color: black,
      border: "1px solid #222138",
      width: 180,
    },
  },

  {
    id: "2",

    data: {
      label: (
        <>
          <strong>Shadows</strong>
        </>
      ),
    },
    position: { x: -1772, y: 332 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 180,
    },
  },

  {
    id: "3",
    data: {
      label: (
        <>
          <strong>Transform function</strong>
          <p className="">
            The transform function lets you rotate, resize, distort, or move an
            element in 2D or 3D space.
          </p>
        </>
      ),
    },
    position: { x: 1804, y: 242 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "4",
    data: {
      label: (
        <>
          <strong>text-shadow</strong>
          <p></p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="box-shadow"
            src="https://codepen.io/jonathanelias1/embed/preview/jOxXjVj?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/jOxXjVj">
              box-shadow
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
          {/* <p className="text-shadow-1">
            Item 1 = .item1{`{text-shadow: 0.5px 0.5px;}`};
          </p>
          <p className="text-shadow-2">
            {" "}
            Colored shadow, Item 2 = .item2{`{text-shadow: 2px 2px red;}`}
          </p>
          <p className="text-shadow-3">
            {" "}
            Blur effect, Item 3 = .item3{`{text-shadow: 2px 2px 5px red;}`}
          </p>
          <p className="text-shadow-4">
            Add multiple shadows with comma-separator, <br /> Item 4 = .item4
            {`{  text-shadow: 0 0 3px #FF0000, 0 0 5px #0000FF;}`}{" "}
          </p>
          <p className="text-shadow-5">
            Item 5 .item5
            {`{text-shadow: 1px 1px 2px black, 0 0 25px blue, 0 0 5px darkblue;`}
            <br />
            {`color: white;}`}
          </p>
          <p className="text-shadow-6">
            Put a border around text with text-shadow, Item 6 = .item6
            {`{  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;`}
            <br />
            {`color: coral;}`}
          </p> */}
        </>
      ),
    },
    position: { x: -2690, y: 630 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "5",
    data: {
      label: (
        <>
          <strong>transform: scale()</strong>
          <p>
            Syntax <br />
            scale(sx) <br />
            scale(sx, sy) <br /> <br />
            Note:
            <br /> <br />
            scaleX(sx) is equivalent to scale(sx, 1).
            <br />
            scaleY(sy) is equivalent to scale(1, sy).
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="Scale"
            src="https://codepen.io/jonathanelias1/embed/preview/dyeObzG?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/dyeObzG">Scale</a> by
            Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 706, y: 622 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "6",
    data: {
      label: (
        <>
          <strong>filter: opacity()</strong>
          <p className="">
            The opacity describes the transparency-level, where 1 is not
            transparent at all, 0.5 is 50% see-through, and 0 is completely
            transparent.
            <br /> <br />
            Syntax <br /> <br />
            filter: opacity(amount);
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="text-shadow"
            src="https://codepen.io/jonathanelias1/embed/preview/XWqoLgK?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/XWqoLgK">
              text-shadow
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
          {/* <div className="whale-photo">
            <p className="transparent-box">
              <span className="opacity-1"> This text </span>and image below will
              change opacity on mouse hover. <br />
              {`{p{opacity: 1;}}`} <br />
              {`p:hover{opacity: 0.5;}`} <br /> <br />
              {`img{opacity: 0.5;}`} <br />
              {`img:hover{opacity: 1;}`}
              <br />
              <br />
              You can also set a transparent background for an element by using
              rgba and opacity. Note the last number represents the opacity and
              the first 3 will determine your color.
              <br />
              <br />
              {`.transparent-box{background: rgba(255, 255, 255, 0.5);}`}
              <br /> I also disabled this transparent box on hover with this:
              <br />
              {`.transparent-box{background: rgba(255, 255, 255, 0);}`}
            </p>
            <img className="opacity-2" src={whaleSpace}></img>
          </div> */}
        </>
      ),
    },
    position: { x: -2498, y: 2330 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 1100,
    },
  },

  {
    id: "7",
    data: {
      label: (
        <>
          <strong>background-image</strong>
          <br />
          <br />
          <iframe
            height="900"
            width="100%"
            scrolling="no"
            title="background image in css grid"
            src="https://codepen.io/jonathanelias1/embed/preview/ExLGJPQ?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/ExLGJPQ">
              background image in css grid
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -6760, y: 640 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 2000,
    },
  },

  {
    id: "8",
    data: {
      label: (
        <>
          <strong>box-shadow</strong>
          <p className="">Attaches one or more shadows to an element.</p>
          <iframe
            height="600"
            width="100%"
            scrolling="no"
            title="box-shadow"
            src="https://codepen.io/jonathanelias1/embed/preview/XWqoLXX?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/XWqoLXX">
              box-shadow
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
          {/* <p className="box-shadow-example-1">
            Box Shadows: <br />
            .item1{`{box-shadow: 2px 2px;}`};
          </p>
          <br />
          <p className="box-shadow-example-2">
            Colored Box shadow <br />
            .item2{`{box-shadow: 2px 2px red;}`}
          </p>
          <br />
          <p className="box-shadow-example-3">
            blur effect <br />
            .item3{`{box-shadow: 2px 2px 5px red;}`}
          </p>
          <br />
          <p className="box-shadow-example-5">
            Add colors to multiple sides
            <br />
            .item4
            {`{box-shadow: 1px 1px 2px black, 0 0 25px blue, 0 0 5px darkblue;}`}
          </p>
          <br />
          <p className="box-shadow-example-6">
            Multiple Shadows <br />
            .item5
            {`{box-shadow: 5px 5px blue, 10px 10px red, 15px 15px green;}`}
          </p>
          <br />
          <p className="box-shadow-example-7">
            Multiple shadows with blur effect <br />
            .item6
            {`{box-shadow: 5px 5px 8px blue, 10px 10px 8px red, 15px 15px 8px green;}`}
          </p> */}
        </>
      ),
    },
    position: { x: -2030, y: 624 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 650,
    },
  },

  {
    id: "9",
    data: {
      label: (
        <>
          <strong>filter:</strong>
          <p className="">Defines visual effects to an element</p>
        </>
      ),
    },
    position: { x: -620, y: 235 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "10",
    data: {
      label: (
        <>
          <strong>filter: drop-shadow</strong>
          <p className="">
            Applies a drop shadow effect to the input image
            <br /> <br />
            Syntax <br /> <br />
            filter: drop-shadow(offset-x offset-y blur-radius color);
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="drop-shadow()"
            src="https://codepen.io/jonathanelias1/embed/preview/qBYqEay?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/qBYqEay">
              drop-shadow()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1320, y: 628 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "11",
    data: {
      label: (
        <>
          <strong>z-index:</strong>
          <p className="">
            Specifies the stack order of an element. An element with greater
            stack order is always in front of an element with a lower stack
            order.
          </p>

          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="Z-index"
            src="https://codepen.io/jonathanelias1/embed/preview/gOzLOzQ?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/gOzLOzQ">Z-index</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -4624, y: 644 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "15",
    data: {
      label: (
        <>
          <strong>transform: matrix()</strong>
          <p>
            The matrix() function is specified with six values. The constant
            values are implied and not passed as parameters; the other
            parameters are described in the column-major order.
            <br />
            <br />
            Syntax
            <br />
            <br /> transform: matrix(a, b, c, d, tx, ty);
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="Matrix"
            src="https://codepen.io/jonathanelias1/embed/preview/YzLpzwr?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/YzLpzwr">Matrix</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1364, y: 3000 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "16",
    data: {
      label: (
        <>
          <strong>transform: matrix3d()</strong>
          <p>
            Defines a 3D transformation as a 4x4 homogeneous matrix The
            matrix3d() function is specified with 16 values. They are described
            in the column-major order.
            <br />
            <br />
            Syntax <br />
            <br />
            transform: matrix3d(a1, b1, c1, d1, a2, b2, c2, d2, a3, b3, c3, d3,
            a4, b4, c4, d4)
          </p>

          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="Matrix3d()"
            src="https://codepen.io/jonathanelias1/embed/preview/abGBbJB?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/abGBbJB">
              Matrix3d()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 706, y: 3000 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "17",
    data: {
      label: (
        <>
          <strong>transform: perspective()</strong>
          <p>
            Defines how far the object is away from the user. So, a lower value
            will result in a more intensive 3D effect than a higher value.
          </p>

          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="CSS Perspective"
            src="https://codepen.io/jonathanelias1/embed/preview/oNdzLVM?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/oNdzLVM">
              CSS Perspective
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 2008, y: 3000 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "18",
    data: {
      label: (
        <>
          <strong>transform: rotate()</strong>
          <p>
            Defines a transformation that rotates an element around a fixed
            point on the 2D plane, without deforming it.
            <br /> <br />
            Syntax <br /> <br />
            transform: rotate(a);
            <br /> <br />
            Note: rotateZ(a) is equivalent to rotate(a).
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="transform: rotate()"
            src="https://codepen.io/jonathanelias1/embed/preview/YzLpPxM?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/YzLpPxM">
              transform: rotate()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 2024, y: 614 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "19",
    data: {
      label: (
        <>
          <strong>transform: rotate3d()</strong>
          <p>
            {" "}
            Defines a transformation that rotates an element around a fixed axis
            in 3D space, without deforming it.
            <br /> <br />
            Syntax <br /> <br />
            Note: a = angle <br /> <br />
            transform: rotate3d(x, y, z, a);
            <br />
            <br />
            Note:
            <br />
            <br />
            rotateX(a) is equivalent to rotate3d(1, 0, 0, a). <br />
            rotateY(a) is equivalent to rotate3d(0, 1, 0, a). <br />
            rotateZ(a) is equivalent to rotate3d(0, 0, 1, a).
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="transform: rotate3d()"
            src="https://codepen.io/jonathanelias1/embed/preview/YzLpPJm?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/YzLpPJm">
              transform: rotate3d()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 2671, y: 610 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "20",
    data: {
      label: (
        <>
          <strong>transform: scale3d()</strong>
          <p>
            Defines a transformation that resizes an element in 3D space.
            Because the amount of scaling is defined by a vector, it can resize
            different dimensions at different scales.
            <br /> <br />
            Syntax <br /> <br />
            transform: scale3d(sx, sy, sz);
            <br />
            <br />
            Note: <br />
            <br />
            scaleX(sx) is equivalent to scale3d(sx, 1, 1).
            <br />
            scaleY(sy) is equivalent to scale3d(1, sy, 1).
            <br />
            scaleZ(sz) is equivalent to scale3d(1, 1, sz).
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="transform: scale3d()"
            src="https://codepen.io/jonathanelias1/embed/preview/poVNJNK?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/poVNJNK">
              transform: scale3d()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1370, y: 608 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "21",
    data: {
      label: (
        <>
          <strong>transform: skew()</strong>
          <p>
            Defines a transformation that skews an element on the 2D plane.
            <br /> <br />
            Syntax <br /> <br />
            transform: skew(ax) <br />
            transform: skew(ax, ay) Note: <br /> <br />
            skewX(a) is equivalent to skew(a).
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="transform: skew()"
            src="https://codepen.io/jonathanelias1/embed/preview/xxjRGdv?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/xxjRGdv">Untitled</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 2008, y: 1880 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "22",
    data: {
      label: (
        <>
          <strong>transform: skewY()</strong>
          <p>
            Defines a transformation that skews an element in the vertical
            direction on the 2D plane.
            <br /> <br />
            Syntax <br /> <br />
            transform: skewY(a);
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="transform: skewY()"
            src="https://codepen.io/jonathanelias1/embed/preview/Jjvbdvo?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/Jjvbdvo">
              transform: skewY()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 2658, y: 1880 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "23",
    data: {
      label: (
        <>
          <strong>transform: translate()</strong>
          <p>
            Repositions an element in the horizontal and/or vertical directions.
            <br /> <br />
            Syntax <br /> <br />
            transform: translate(X-axis value) <br />
            transform: translate(X-axis value, y-axis value)
            <br /> <br />
            Note:
            <br /> <br />
            translateX(tx) is equivalent to translate(tx, 0).
            <br />
            translateY(ty) is equivalent to translate(0, ty).
            <br />
            scaleZ(sz) is equivalent to scale3d(1, 1, sz).
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="transform: translate()"
            src="https://codepen.io/jonathanelias1/embed/preview/oNdYXaL?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/oNdYXaL">
              transform: translate()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 708, y: 1880 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "24",
    data: {
      label: (
        <>
          <strong>transform: translate3d()</strong>
          <p>
            Repositions an element in 3D space.
            <br /> <br />
            Syntax <br /> <br />
            translate3d(tx, ty, tz)
            <br /> <br />
            Note:
            <br /> <br />
            translateX(tx) is equivalent to translate3d(tx, 0, 0).
            <br />
            translateY(ty) is equivalent to translate3d(0, ty, 0).
            <br />
            translateZ(tz) is equivalent to translate3d(0, 0, tz).
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="transform: translate3d()"
            src="https://codepen.io/jonathanelias1/embed/preview/xxjRGNZ?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/xxjRGNZ">
              transform: translate3d()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1368, y: 1880 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  // {
  //   id: "25",
  //   data: {
  //     label: (
  //       <>
  //         <strong>mix-blend-mode</strong>
  //         <p></p>
  //       </>
  //     ),
  //   },
  //   position: { x: 0, y: 0 },
  //   style: {
  //     background: level2,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  {
    id: "26",

    data: {
      label: (
        <>
          <strong>float</strong>
          <p>
            Specifies how an element should float and is primarily used to
            position content. The float property can have one of the following
            values: <br /> <br />
          </p>
          <p>
            {" "}
            Syntax: <br /> <br />
            float:(left/right/none/inherit);
          </p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="filter: saturate()"
            src="https://codepen.io/jonathanelias1/embed/preview/yLjgoae?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/yLjgoae">
              filter: saturate()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -7010, y: 1710 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 2500,
    },
  },

  {
    id: "27",
    data: {
      label: (
        <>
          <strong>filter: blur()</strong>
          <p className="">
            Applies a Gaussian blur to the input image
            <br /> <br />
            Syntax <br /> <br />
            filter: blur(radius);
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="filter: blur()"
            src="https://codepen.io/jonathanelias1/embed/preview/mdLOzLO?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/mdLOzLO">
              filter: blur()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 44, y: 628 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "28",
    data: {
      label: (
        <>
          <strong>filter: brightness()</strong>
          <p className="">
            Applies a linear multiplier to the input image, making it appear
            brighter or darker.
            <br /> <br />
            Syntax <br /> <br />
            filter: brightness(amount);
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="filter: brightness()"
            src="https://codepen.io/jonathanelias1/embed/preview/KKRNGxB?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/KKRNGxB">
              filter: brightness()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 38, y: 1482 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "29",
    data: {
      label: (
        <>
          <strong>filter: contrast()</strong>
          <p className="">
            {" "}
            Adjusts the contrast of the input image.
            <br /> <br />
            Syntax <br /> <br />
            filter: contrast(amount)
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="filter: brightness()"
            src="https://codepen.io/jonathanelias1/embed/preview/PoebyMO?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/PoebyMO">
              filter: brightness()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -638, y: 1498 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "30",
    data: {
      label: (
        <>
          <strong>filter: grayscale()</strong>
          <p className="">
            Converts the input image to grayscale.
            <br /> <br />
            Syntax <br /> <br />
            filter: grayscale(amount)
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="filter: contrast()"
            src="https://codepen.io/jonathanelias1/embed/preview/OJZbayv?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/OJZbayv">
              filter: contrast()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -644, y: 2440 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "31",
    data: {
      label: (
        <>
          <strong>filter: hue-rotate()</strong>
          <p className="">
            Rotates the hue of an element and its contents.
            <br /> <br />
            Syntax <br /> <br />
            filter: hue-rotate(angle)
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="filter: hue-rotate()"
            src="https://codepen.io/jonathanelias1/embed/preview/qBYqQaa?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/qBYqQaa">
              filter: hue-rotate()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 36, y: 2440 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "32",
    data: {
      label: (
        <>
          <strong>filter: invert()</strong>
          <p className="">
            Inverts the color samples in the input image.
            <br /> <br />
            Syntax <br /> <br />
            filter: invert(amount);
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="filter: hue-rotate()"
            src="https://codepen.io/jonathanelias1/embed/preview/ZEoBmez?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/ZEoBmez">
              filter: hue-rotate()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1334, y: 2440 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "33",
    data: {
      label: (
        <>
          <strong>filter: sephia()</strong>
          <p className="">
            Converts the input image to sepia, giving it a warmer, more
            yellow/brown appearance
            <br /> <br />
            Syntax <br /> <br />
            filter: sephia(amount);
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="filter: invert()"
            src="https://codepen.io/jonathanelias1/embed/preview/xxjRQrE?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/xxjRQrE">
              filter: invert()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1332, y: 1504 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "34",
    data: {
      label: (
        <>
          <strong>filter: saturate()</strong>
          <p className="">
            Super-saturates or desaturates the input image.
            <br /> <br />
            Syntax <br /> <br />
            filter: saturate(amount);
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="filter: sephia()"
            src="https://codepen.io/jonathanelias1/embed/preview/yLjVQzm?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/yLjVQzm">
              filter: sephia()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -624, y: 628 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  // {
  //   id: "35",
  //   data: {
  //     label: (
  //       <>
  //         <p className="node-title">
  //           <Link className="link-to-node" to="/pseudoclasses">
  //             Pseudo-classes
  //           </Link>
  //         </p>
  //       </>
  //     ),
  //   },
  //   position: { x: 0, y: 0 },
  //   style: {
  //     background: level2,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // {
  //   id: "36",
  //   data: {
  //     label: (
  //       <>
  //         <strong>Pseudo-elements</strong>
  //         <p></p>
  //       </>
  //     ),
  //   },
  //   position: { x: 0, y: 0 },
  //   style: {
  //     background: level2,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // {
  //   id: "37",
  //   data: {
  //     label: (
  //       <>
  //         <strong>At-rules</strong>
  //         <p></p>
  //       </>
  //     ),
  //   },
  //   position: { x: 0, y: 0 },
  //   style: {
  //     background: level2,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  {
    id: "38",

    data: {
      label: (
        <>
          <strong>clear</strong>
          <p>
            Controls the flow next to floated elements to specify what should
            happen with the element that is next to a floating element. The
            clear property applies to floating and non-floating elements.
          </p>
          <br /> <br />
          <p>
            When applied to non-floating blocks, it moves the border edge of the
            element down until it is below the margin edge of all relevant
            floats. The non-floated block's top margin collapses.
          </p>
          <p>
            <iframe
              height="800"
              width="100%"
              scrolling="no"
              title="clear"
              src="https://codepen.io/jonathanelias1/embed/preview/jOxyGoK?default-tab=result&editable=true"
              frameBorder="no"
              loading="lazy"
              allowtransparency="true"
              allowFullScreen={true}
            >
              See the Pen{" "}
              <a href="https://codepen.io/jonathanelias1/pen/jOxyGoK">clear</a>{" "}
              by Jonathan Elias (
              <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>)
              on <a href="https://codepen.io">CodePen</a>.
            </iframe>
          </p>
        </>
      ),
    },
    position: { x: -4266, y: 1700 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 1500,
    },
  },

  {
    id: "39",
    data: {
      label: (
        <>
          <strong>resize</strong>
          <p>
            Defines if (and how) an element is resizable by the user.
            <br /> <br />
            Note: <br /> <br />
            Resize does not apply to inline elements or to block elements where
            overflow="visible". So, make sure that overflow is set to "scroll",
            "auto", or "hidden".
          </p>

          <iframe
            height="600"
            width="100%"
            scrolling="no"
            title="resize"
            src="https://codepen.io/jonathanelias1/embed/preview/JjvWyNJ?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/JjvWyNJ">resize</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -3872, y: 648 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 710,
    },
  },

  {
    id: "40",
    data: {
      label: (
        <>
          <strong>Handling images and text</strong>
          <p></p>
        </>
      ),
    },
    position: { x: -4670, y: 332 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 710,
    },
  },

  // End of items
];

export const edges = [
  {
    id: "e1-2",
    source: "1",
    target: "2",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-3",
    source: "1",
    target: "3",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-9",
    source: "1",
    target: "9",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-40",
    source: "1",
    target: "40",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Shadows

  {
    id: "e2-10",
    source: "2",
    target: "10",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e2-8",
    source: "2",
    target: "8",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e2-4",
    source: "2",
    target: "4",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //filter

  {
    id: "e9-6",
    source: "9",
    target: "6",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-10",
    source: "9",
    target: "10",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-27",
    source: "9",
    target: "27",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-28",
    source: "9",
    target: "28",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-29",
    source: "9",
    target: "29",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-30",
    source: "9",
    target: "30",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-31",
    source: "9",
    target: "31",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-32",
    source: "9",
    target: "32",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-33",
    source: "9",
    target: "33",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-34",
    source: "9",
    target: "34",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //transform

  {
    id: "e3-5",
    source: "3",
    target: "5",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e3-15",
    source: "3",
    target: "15",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e3-16",
    source: "3",
    target: "16",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e3-17",
    source: "3",
    target: "17",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e3-18",
    source: "3",
    target: "18",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e3-19",
    source: "3",
    target: "19",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e3-20",
    source: "3",
    target: "20",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e3-21",
    source: "3",
    target: "21",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e3-22",
    source: "3",
    target: "22",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e3-23",
    source: "3",
    target: "23",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e3-24",
    source: "3",
    target: "24",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //handling images and text

  {
    id: "e40-11",
    source: "40",
    target: "11",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e40-7",
    source: "40",
    target: "7",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e40-39",
    source: "40",
    target: "39",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e40-26",
    source: "40",
    target: "26",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e40-38",
    source: "40",
    target: "38",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //   {
  //     id: "e8-10",
  //     source: "8",
  //     target: "10",
  //     animated: true,
  //     style: { stroke: "#f6ab6c" },
  //     markerEnd: {
  //       type: MarkerType.ArrowClosed,
  //     },
  //   },

  //END
];
